import { AnyAction } from 'redux';
import { RomEditorState } from 'routes/rom/interfaces';

export enum RomEventTypes {
    SET_ROM = 'ROM__SET_ROM',
    SET_ROM_VALUE = 'ROM__SET_ROM_VALUE',
    CLEAR_ROM = 'ROM__CLEAR_ROM',

    CREATE_META_DATA_LIST = 'ROM__CREATE_META_DATA_LIST',
    REMOVE_META_DATA_LIST = 'ROM__REMOVE_META_DATA_LIST',
    CREATE_META_DATA_ITEM = 'ROM__CREATE_META_DATA_ITEM',
    REMOVE_META_DATA_ITEM = 'ROM__REMOVE_META_DATA_ITEM',
    UPDATE_META_DATA_ITEM_VALUE = 'ROM__UPDATE_META_DATA_ITEM_VALUE',
}

export enum RomApiEventTypes {
    GET_ROM = 'API_FETCH__GET_ROM',
    POST_ROM = 'API_FETCH__POST_ROM',
    PUT_ROM = 'API_FETCH__PUT_ROM',
}

export const GET_ROM = RomApiEventTypes.GET_ROM;
export const POST_ROM = RomApiEventTypes.POST_ROM;
export const PUT_ROM = RomApiEventTypes.PUT_ROM;

export interface RomUpdateAction<K extends keyof RomEditorState> extends AnyAction {
    type: RomEventTypes.SET_ROM_VALUE;
    name: K;
    value: RomEditorState[K];
}
